var CsAgGridCustomUserRendererComponent = /** @class */ (function () {
    function CsAgGridCustomUserRendererComponent() {
        this.assignees = [];
        this.fallbackImage = 'images/profile_avatar_small.jpg';
    }
    CsAgGridCustomUserRendererComponent.prototype.agInit = function (params) {
        this.params = params;
    };
    CsAgGridCustomUserRendererComponent.prototype.refresh = function (params) {
        this.params = params;
        return true;
    };
    CsAgGridCustomUserRendererComponent.prototype.getInitials = function (name) {
        if (!name) {
            return '';
        }
        return name
            .split(' ')
            .map(function (word) { return word.charAt(0); })
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };
    return CsAgGridCustomUserRendererComponent;
}());
export { CsAgGridCustomUserRendererComponent };
